export default function Footer() {
  return (
    <footer className="bg-site-dark text-white border-t border-white/10">
      <div className="container mx-auto px-4 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">合同会社WakuWaku</h3>
            <p className="text-zinc-400 mb-4 leading-relaxed">
              音響効果<br />
              大阪・箕面市の静かな一室から、<br />
              映像・空間・人の心を"音"でつなぐサウンドクリエイターです。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4 text-teal-300">お問い合わせ</h4>
            <div className="space-y-3 text-zinc-300">
              <p className="flex items-center">
                <i className="ri-mail-line mr-2 text-teal-400"></i>
                waku-w.company@waku-waku.biz
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2 text-teal-400"></i>
                090-3672-6149
              </p>
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-teal-400"></i>
                大阪府箕面市小野原東2丁目3番22号
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-4 text-teal-300">フォローする</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.youtube.com/@WakuWaku%E3%83%81%E3%83%A3%E3%83%B3%E3%83%8D%E3%83%AB/videos"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-white/10 rounded-full hover:bg-teal-500 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-white"></i>
              </a>
              <a
                href="https://www.facebook.com/WakuWakuTaizo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center bg-white/10 rounded-full hover:bg-teal-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 text-center text-zinc-500">
          <p>&copy; 2024 合同会社WakuWaku. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}